import './AllTeachers.css';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDarkMode } from "../../contexts/DarkModeContext";

import { BsPlusCircleFill } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { fetchTeachersBySubject, fetchTeachers, setCurrentSubject, setCurrentPage, getAllTeachersForParent, getSubscribedTeachersForParent, getChildSubjectTeachers } from "../../redux/slices/teachersSlice";
import { getStudentSubjects } from "../../redux/slices/subjectsSlice";
import { getChildSubjects } from "../../redux/slices/lessonsSlice";
import { getParentChildren } from "../../redux/slices/lessonsSlice";

function AllTeachers() {
  const { isDarkMode } = useDarkMode();
  const dispatch = useDispatch();
  const { teachers, loading, error, pagination, currentSubject, currentPage, allTeachersForParent, allTeachersForParentLoading, subscribedTeachersForParent, subscribedTeachersForParentLoading, childSubjectTeachers, childSubjectTeachersLoading } = useSelector((state) => state.teachers);
  const { studentSubjects, subjectsLoading } = useSelector((state) => state.subjects);
  const { childSubjects, childSubjectsLoading } = useSelector((state) => state.lessons);
  const { parentChildren, parentChildrenLoading } = useSelector((state) => state.lessons);
  const { currentUser } = useSelector((state) => state.auth);
  const userRole = currentUser?.role || localStorage.getItem("userRole");
  const [activeTab, setActiveTab] = useState("الكل");
  const [activeParentTab, setActiveParentTab] = useState("all"); // all, subjects, subscribed
  const [subscriptionFilter, setSubscriptionFilter] = useState("all"); // "all" or "subscribed"
  
  // متغيرات جديدة لولي الأمر
  const [selectedChild, setSelectedChild] = useState(null);
  const [selectedSubjectId, setSelectedSubjectId] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Check if user is authenticated and fetch subjects
  const isAuthenticated = !!localStorage.getItem("token3almny");

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getStudentSubjects());
      // Fetch all teachers on initial load
      dispatch(fetchTeachers());
    }
  }, [dispatch, isAuthenticated]);

  // جلب بيانات لولي الأمر
  useEffect(() => {
    if (isAuthenticated && userRole === "parent") {
      dispatch(getParentChildren());
    }
  }, [dispatch, isAuthenticated, userRole]);

  // تحديث selectedChild عند تغيير parentChildren
  useEffect(() => {
    if (parentChildren?.length > 0 && !selectedChild) {
      const firstChild = parentChildren[0];
      setSelectedChild(firstChild);
      // جلب مواد الابن الأول مباشرة
      if (firstChild) {
        dispatch(getChildSubjects(firstChild.id));
      }
    }
  }, [parentChildren, selectedChild, dispatch]);

  // جلب مواد الابن عند تغيير الابن المختار (لولي الأمر)
  useEffect(() => {
    if (selectedChild) {
      dispatch(getChildSubjects(selectedChild.id));
    }
  }, [selectedChild, dispatch]);

  // جلب مدرسين المادة عند تغيير الابن أو المادة (لولي الأمر)
  useEffect(() => {
    if (selectedChild && userRole === "parent") {
      if (activeParentTab === "all") {
        dispatch(getAllTeachersForParent({ 
          childId: selectedChild.id, 
          page: 1, 
          perPage: 15 
        }));
      } else if (activeParentTab === "subscribed") {
        dispatch(getSubscribedTeachersForParent({ 
          childId: selectedChild.id, 
          page: 1, 
          perPage: 15 
        }));
      }
    }
  }, [selectedChild, activeParentTab, dispatch, userRole]);

  // جلب مدرسين المادة عند تغيير المادة المختارة (لولي الأمر)
  useEffect(() => {
    if (selectedChild && userRole === "parent" && selectedSubjectId !== undefined) {
      dispatch(getChildSubjectTeachers({ 
        childId: selectedChild.id, 
        subjectId: selectedSubjectId,
        page: 1,
        perPage: 15
      }));
    }
  }, [selectedChild, selectedSubjectId, dispatch, userRole]);

  // Static teachers data for guest mode
  const staticTeachers = [
    {
      id: 1,
      name: "اسم المدرس",
      subject: "علوم",
      lessons: 32,
      students: "+50",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      id: 2,
      name: "اسم المدرس",
      subject: "علوم",
      lessons: 32,
      students: "+50",
      image: "https://randomuser.me/api/portraits/men/34.jpg",
    },
    {
      id: 3,
      name: "اسم المدرس",
      subject: "علوم",
      lessons: 32,
      students: "+50",
      image: "https://randomuser.me/api/portraits/men/36.jpg",
    },
    {
      id: 4,
      name: "اسم المدرس",
      subject: "علوم",
      lessons: 32,
      students: "+50",
      image: "https://randomuser.me/api/portraits/men/34.jpg",
    },
  ];

  // Create subjects array with "الكل" option and dynamic subjects
  const subjects = [
    { name: "الكل", id: 0 },
    ...(studentSubjects.map(subject => ({
      name: subject.title,
      id: subject.id
    })))
  ];

  // Handle subject tab change
  const handleSubjectTabChange = (tabName) => {
    setActiveTab(tabName);
    setSubscriptionFilter("all"); // Reset subscription filter when changing subject
    
    const selectedSubject = subjects.find(subject => subject.name === tabName);
    
    if (selectedSubject) {
      dispatch(setCurrentSubject(selectedSubject.id));
      dispatch(setCurrentPage(1));
      
      if (isAuthenticated) {
        if (selectedSubject.id === 0) {
          // Use fetchTeachers for "الكل" - this now uses the correct endpoint
          dispatch(fetchTeachers());
        } else {
          // Use fetchTeachersBySubject for specific subjects
          dispatch(fetchTeachersBySubject({ subjectId: selectedSubject.id, page: 1 }));
        }
      }
    }
  };

  // Handle subscription filter change
  const handleSubscriptionFilterChange = (filter) => {
    setSubscriptionFilter(filter);
  };

  // دالة تغيير تابس لولي الأمر
  const handleParentTabChange = (tabName) => {
    setActiveParentTab(tabName);
    if (userRole === "parent" && selectedChild) {
      if (tabName === "all") {
        dispatch(getAllTeachersForParent({ 
          childId: selectedChild.id, 
          page: 1, 
          perPage: 15 
        }));
      } else if (tabName === "subscribed") {
        dispatch(getSubscribedTeachersForParent({ 
          childId: selectedChild.id, 
          page: 1, 
          perPage: 15 
        }));
      }
    }
  };

  // دالة تغيير المادة لولي الأمر
  const handleSubjectChange = (subjectId) => {
    setSelectedSubjectId(subjectId);
  };

  // Handle page change
  const handlePageChange = (page) => {
    dispatch(setCurrentPage(page));
    const selectedSubject = subjects.find(subject => subject.name === activeTab);
    
    if (isAuthenticated && selectedSubject) {
      if (selectedSubject.id === 0) {
        // For "الكل", we don't need pagination as fetchTeachers doesn't support it
        dispatch(fetchTeachers());
      } else {
        // Use fetchTeachersBySubject for specific subjects with pagination
        dispatch(fetchTeachersBySubject({ subjectId: selectedSubject.id, page }));
      }
    }
  };

  // Filter teachers based on subscription status
  const getFilteredTeachers = () => {
    if (!isAuthenticated) return staticTeachers;
    
    if (subscriptionFilter === "subscribed") {
      return teachers.filter(teacher => teacher.is_subscribed === true);
    } else {
      return teachers;
    }
  };

  // Get teachers to display based on user role
  const getTeachersToDisplay = () => {
    if (userRole === "parent") {
      // لولي الأمر: عرض مدرسين الأبناء
      if (activeParentTab === "subscribed") {
        return subscribedTeachersForParent?.data || [];
      } else if (selectedSubjectId > 0) {
        // إذا تم اختيار مادة محددة، اعرض مدرسين المادة
        return childSubjectTeachers?.data || [];
      } else {
        // إذا لم يتم اختيار مادة أو تم اختيار "الكل"، اعرض جميع المدرسين
        return allTeachersForParent?.data || [];
      }
    } else {
      // للطلاب والمعلمين: عرض المدرسين العاديين
      return getFilteredTeachers();
    }
  };

  // Get teachers to display
  const teachersToDisplay = getTeachersToDisplay();

  return (
    <div className={`all-lessons-page ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="container">
        {/* Breadcrumb */}
        <div className="lessons-breadcrumb">
          <h1 className="breadcrumb-title">المدرسين</h1>
          <div className="breadcrumb-links2">
            <span className="breadcrumb-link">الرئيسية</span>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">المدرسين</span>
          </div>
        </div>

        {/* Dropdown لاختيار الابن - للمستخدمين من نوع "parent" فقط */}
        {userRole === "parent" && (
          <div className="child-selector mb-4">
            <label htmlFor="childSelect" className="form-label fw-bold text-primary mb-2">
              اختر الابن:
            </label>
            <select
              id="childSelect"
              className="form-select"
              value={selectedChild?.id || ""}
              onChange={(e) => {
                const child = parentChildren.find(c => c.id == e.target.value);
                setSelectedChild(child);
                // إعادة تعيين المادة إلى الكل عند تغيير الابن
                setSelectedSubjectId(0);
              }}
              disabled={parentChildrenLoading}
            >
              {parentChildrenLoading ? (
                <option>جاري التحميل...</option>
              ) : parentChildren?.length > 0 ? (
                parentChildren.map(child => (
                  <option key={child.id} value={child.id}>
                    {child.name}
                  </option>
                ))
              ) : (
                <option>لا يوجد أبناء</option>
              )}
            </select>
          </div>
        )}

        {/* Subject Tabs - للطلاب والمعلمين فقط */}
        {userRole !== "parent" && (
          <div className="lessons-tabs">
            <div className="tabs-header">
              <span className="subjects-text">المواد</span>
              <div className="tabs-container">
                {subjects.map((subject) => (
                  <button
                    key={subject.name}
                    className={`tab-button ${activeTab === subject.name ? 'active' : ''}`}
                    onClick={() => handleSubjectTabChange(subject.name)}
                  >
                    {subject.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Subscription Filter Tabs - للطلاب والمعلمين فقط */}
        {userRole !== "parent" && activeTab && (
          <div className="lessons-tabs">
            <div className="tabs-header">
              <span className="subjects-text">الاشتراكات</span>
              <div className="tabs-container">
                <button
                  className={`tab-button ${subscriptionFilter === "all" ? 'active' : ''}`}
                  onClick={() => handleSubscriptionFilterChange("all")}
                >
                  جميع المدرسين
                </button>
                <button
                  className={`tab-button ${subscriptionFilter === "subscribed" ? 'active' : ''}`}
                  onClick={() => handleSubscriptionFilterChange("subscribed")}
                >
                  تم الاشتراك معهم
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Parent Tabs - للمستخدمين من نوع "parent" فقط */}
        {userRole === "parent" && selectedChild && (
          <div className="lessons-tabs">
            <div className="tabs-header">
              <span className="subjects-text">مدرسين الأبناء</span>
              <div className="tabs-container">
                <button
                  className={`tab-button ${activeParentTab === "all" ? 'active' : ''}`}
                  onClick={() => handleParentTabChange("all")}
                >
                  جميع المدرسين
                </button>
                <button
                  className={`tab-button ${activeParentTab === "subscribed" ? 'active' : ''}`}
                  onClick={() => handleParentTabChange("subscribed")}
                >
                  تم الاشتراك معهم
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Tabs المواد - للمستخدمين من نوع "parent" فقط بعد اختيار الابن */}
        {userRole === "parent" && selectedChild && (
          <div className="lessons-tabs">
            <div className="tabs-header">
              <span className="subjects-text">المواد</span>
              <div className="tabs-container">
                {/* خيار الكل */}
                <button
                  className={`tab-button ${selectedSubjectId === 0 ? 'active' : ''}`}
                  onClick={() => handleSubjectChange(0)}
                >
                  الكل
                </button>
                
                {/* باقي المواد */}
                {childSubjects?.data && childSubjects.data.length > 0 && childSubjects.data.map((subject) => (
                  <button
                    key={subject.id}
                    className={`tab-button ${selectedSubjectId === subject.id ? 'active' : ''}`}
                    onClick={() => handleSubjectChange(subject.id)}
                  >
                    {subject.title}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Loading State */}
        {(loading || subjectsLoading || (userRole === "parent" && (allTeachersForParentLoading || subscribedTeachersForParentLoading || childSubjectTeachersLoading)) || childSubjectsLoading) && (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">جاري التحميل...</span>
            </div>
          </div>
        )}

        {/* Teachers Grid */}
        <div className="teachers-grid">
          {teachersToDisplay.length > 0 ? (
            teachersToDisplay.map((teacher, index) => (
              <Link to={`/teacherDetails/${teacher.id || index}`} className="text-decoration-none" key={teacher.id || index}>
                {teachersToDisplay?.length === 1 ? <div className="teacher-card" style={{width : "300px" , maxWidth : "100%",  margin : '0 auto'}}>
                  <div className="teacher-image">
                    <img 
                      src={teacher.prof_img || teacher.image || "https://randomuser.me/api/portraits/men/32.jpg"} 
                      alt={teacher.name} 
                      onError={(e) => {
                        e.target.src = "https://randomuser.me/api/portraits/men/32.jpg";
                      }}
                    />
                    <BsPlusCircleFill className="plus-icon" />
                  </div>
                  <h3 className="teacher-name mb-3" style={{fontSize : "15px"}}>{teacher.name}</h3>
                  <p className="subject" style={{fontSize : "10px"}}>{teacher.subject_name}</p>
                  <div className="card-footer d-flex text-center mx-auto justify-content-center">
      
                    <div className="info text-center mx-auto ">
                      <span>⭐</span>
                      <span>{teacher.average_rate || teacher.rate || 0} تقييم</span>
                    </div>
                  </div>
                </div> : <div className="teacher-card">
                  <div className="teacher-image">
                    <img 
                      src={teacher.prof_img || teacher.image || "https://randomuser.me/api/portraits/men/32.jpg"} 
                      alt={teacher.name} 
                      onError={(e) => {
                        e.target.src = "https://randomuser.me/api/portraits/men/32.jpg";
                      }}
                    />
                    <BsPlusCircleFill className="plus-icon" />
                  </div>
                  <h3 className="teacher-name mb-3" style={{fontSize : "15px"}}>{teacher.name}</h3>
                  <p className="subject" style={{fontSize : "12px"}}>{teacher.subject_name}</p>
                  <div className="card-footer justify-content-center">
              
                    <div className="info">
                      <span>⭐</span>
                      <span>{teacher.average_rate || teacher.rate || 0} تقييم</span>
                    </div>
                  </div>
                </div>}
              </Link>
            ))
          ) : (
            <div className="text-center w-100">
              <p>لا توجد بيانات للمدرسين</p>
            </div>
          )}
        </div>

        {/* Pagination - Only show for specific subjects, not for "الكل" */}
        {isAuthenticated && pagination && pagination.pages_count > 1 && activeTab !== "الكل" && userRole !== "parent" && (
          <div className="pagination-container mt-4">
            <div className="pagination">
              {Array.from({ length: pagination.pages_count }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AllTeachers; 